import { inject } from "@angular/core";
import { AppConfigService } from "./core/services/app-config.service";

export function appInitializerFactory() {
  const appConfig = inject(AppConfigService);
  return appConfig.loadConfig();
}
